import React from 'react'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import { Props_SnippetJobAd} from './JobAd.props';

export const SnippetJobAd = (props: Props_SnippetJobAd) => {

  const { titleProps, imageProps, jobProps, contentProps } = props;
  const titleClass = titleProps.visibility.value === "visible" ? "snippet-jobad__title" : "snippet-jobad__title accessible-heading";

  return (
    <section className="snippet-jobad"> 
    <div className="snippet-jobad__container">
      {titleProps && <h2 className={titleClass}>{titleProps.text?.value}</h2>}

     { imageProps && <div className="snippet-jobad__image-section">
        <figure className="snippet-jobad__image-container">
          <img src={imageProps.image?.value}
           alt={imageProps.imageAlt?.value}
            height="390"
            width="280"
            className="snippet-jobad__image" />
        </figure>
      </div>}
      { jobProps && <div className="snippet-jobad__job-section">
        {jobProps.jobLocation?.value && <p className="snippet-jobad__location">{jobProps.jobLocation.value}</p>}
        {jobProps.jobTitle?.value && <p className="snippet-jobad__jobtitle">{jobProps.jobTitle.value}</p>}
        {jobProps.jobSalary?.value && <p className="snippet-jobad__salary"><label className='snippet-jobad__salary-label'>{jobProps.jobSalaryLabel.value}</label> {jobProps.jobSalary.value} </p>}
        </div>}

      {contentProps && <div className="snippet-jobad__content-section">
        {contentProps.contentTitle?.value && <h3 className="snippet-jobad__content-title">{contentProps.contentTitle.value}</h3>}
        {contentProps.description?.value && <div className="snippet-jobad__description">{CompileMarkdown(contentProps.description.value || '')}
          </div>}
          </div>}
    </div>
    </section>
  )
}

